import '@angular/localize/init';

import('./bootstrap')
	.catch(err => console.error(err));
